"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DialogRoute = exports.buildDialogQueryFn = void 0;
var tslib_1 = require("tslib");
var React = require("react");
var queryString = require("query-string");
var query_route_1 = require("./query-route");
// This function allows us to find dialogs in a comma-separate series
// eg, foo.com/bar?pwaDialog=dialogA,dialogB,dialogC
var buildDialogQueryFn = function (dialogId) {
  return function (query) {
    return query.split(',').includes(dialogId);
  };
};
exports.buildDialogQueryFn = buildDialogQueryFn;
var DialogRoute = /** @class */function (_super) {
  tslib_1.__extends(DialogRoute, _super);
  function DialogRoute() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  DialogRoute.buildDialogChain = function (query, dialogId, key) {
    if (key === void 0) {
      key = 'pwaDialog';
    }
    var queryObj = queryString.parse(query);
    return queryObj[key] ? "".concat(queryObj[key], ",").concat(dialogId) : dialogId;
  };
  DialogRoute.appendDialogToQuery = function (query, dialogId, key) {
    var _a;
    if (key === void 0) {
      key = 'pwaDialog';
    }
    var queryObj = queryString.parse(query);
    var dialogChain = queryObj[key] ? "".concat(queryObj[key], ",").concat(dialogId) : dialogId;
    var enhancedQuery = tslib_1.__assign(tslib_1.__assign({}, queryObj), (_a = {}, _a[key] = dialogChain, _a));
    return queryString.stringify(enhancedQuery);
  };
  DialogRoute.prototype.render = function () {
    var _a;
    // eslint-disable-next-line react/prop-types
    var _b = this.props,
      children = _b.children,
      id = _b.id,
      type = _b.type,
      useQueryBuilder = _b.useQueryBuilder;
    var query = useQueryBuilder ? (0, exports.buildDialogQueryFn)(id) : id;
    var queryVal = (_a = {}, _a[type] = query, _a);
    return React.createElement(query_route_1.QueryRoute, {
      query: queryVal
    }, children);
  };
  DialogRoute.defaultProps = {
    type: 'pwaDialog',
    useQueryBuilder: true
  };
  return DialogRoute;
}(React.Component);
exports.DialogRoute = DialogRoute;